/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as EmailRouteImport } from './routes/email'
import { Route as FormrRouteImport } from './routes/formr'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as UsersRouteImport } from './routes/users'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailRoute = EmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => rootRouteImport,
} as any)
const FormrRoute = FormrRouteImport.update({
  id: '/formr',
  path: '/formr',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/customers': typeof CustomersRoute
  '/email': typeof EmailRoute
  '/formr': typeof FormrRoute
  '/maintenance': typeof MaintenanceRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/customers': typeof CustomersRoute
  '/email': typeof EmailRoute
  '/formr': typeof FormrRoute
  '/maintenance': typeof MaintenanceRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/customers': typeof CustomersRoute
  '/email': typeof EmailRoute
  '/formr': typeof FormrRoute
  '/maintenance': typeof MaintenanceRoute
  '/users': typeof UsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/customers'
    | '/email'
    | '/formr'
    | '/maintenance'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/customers'
    | '/email'
    | '/formr'
    | '/maintenance'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/customers'
    | '/email'
    | '/formr'
    | '/maintenance'
    | '/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRoute
  CustomersRoute: typeof CustomersRoute
  EmailRoute: typeof EmailRoute
  FormrRoute: typeof FormrRoute
  MaintenanceRoute: typeof MaintenanceRoute
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email': {
      id: '/email'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof EmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/formr': {
      id: '/formr'
      path: '/formr'
      fullPath: '/formr'
      preLoaderRoute: typeof FormrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRoute,
  CustomersRoute: CustomersRoute,
  EmailRoute: EmailRoute,
  FormrRoute: FormrRoute,
  MaintenanceRoute: MaintenanceRoute,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
